import React from 'react';
export const defaultVirtualization = false;
export const defaultVirtualizationThreshold = 250;
export const calcSelectOptionsLength = options => {
  options = options || [];
  const head = options[0] || {};
  const isGrouped = head.options !== undefined;
  return isGrouped ? options.reduce((result, group) => result + group.options.length, 0) : options.length;
};
export const useIsVirtualized = (virtualization, virtualizationThreshold, options) => {
  const isVirtualized = React.useMemo(() => {
    const optionsLength = calcSelectOptionsLength(options);
    return virtualization ? optionsLength >= virtualizationThreshold : false;
  }, [options, virtualization, virtualizationThreshold]);
  return isVirtualized;
};